import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    diagnosisTemplates: [],
    prescriptionTemplates: [],
    diagnosisNotes: [],
    diagnosisLabTests: [],
    lastFetch: null
}

const templatesSlice = createSlice({
    name: "templates",
    initialState,
    reducers: {
        setDiagnosisTemplates: (state, action) => {
            state.diagnosisTemplates = [...action.payload];
        },
        setPrescriptionTemplates: (state, action) => {
            state.prescriptionTemplates = [...action.payload];
        },
        setDiagnosisNotes: (state, action) => {
            state.diagnosisNotes = [...action.payload];
        },
        setDiagnosisLabTests: (state, action) => {
            state.diagnosisLabTests = [...action.payload];
        },
        resetTemplates: (state) => {
            state.diagnosisTemplates = [];
            state.prescriptionTemplates = [];
            state.diagnosisNotes = [];
            state.diagnosisLabTests = [];
        }
    }
})

export const { setDiagnosisTemplates, setPrescriptionTemplates, setDiagnosisNotes, setDiagnosisLabTests, resetTemplates } = templatesSlice.actions;
export default templatesSlice.reducer;